"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoKnownValue = void 0;
const flex_1 = require("@app/component/ui/flex");
const icon_1 = require("@app/component/ui/icon");
const tooltip_1 = require("@app/component/ui/tooltip");
const react_1 = __importDefault(require("react"));
const NoKnownValue = () => (react_1.default.createElement("td", null,
    react_1.default.createElement(flex_1.Flex, { justify: "center" },
        react_1.default.createElement(tooltip_1.Tooltip, { text: 'Pro vybrané řazení není možné spočítat fond.', anchor: react_1.default.createElement(icon_1.Icon, { ico: icon_1.Icon.ICONS.question, size: "small", color: "dark-blue" }) }))));
exports.NoKnownValue = NoKnownValue;
